import { Directive, Input, NgModule, TemplateRef } from '@angular/core';

@Directive({
  selector: '[avanoTemplate]',
})
export class AvanoTemplate {

  @Input() type: string;

  @Input('avanoTemplate') name: string;

  constructor(public template: TemplateRef<any>) {}

  getType(): string {
    return this.name;
  }
}
